import React from "react";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getBreakEntries } from "../../api/entryAPI";
import EntryTable from "./EntryTable";
import Loader from "../Loader";

function BreakEntries() {
    // STATE/HOOKS ====================================================================================
    const {id} = useParams();
    const token = useSelector(state => state.user.token)
    const entries = useSelector(state => state.entries.entries)
    const breakDetail = useSelector(state => state.breaks.breakDetail);
    const loading = useSelector(state => state.entries.loading)
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(getBreakEntries({id, token}))
    }, [dispatch, id, token])

    // HANDLERS ====================================================================================

    // DOM RENDER ====================================================================================
    return(
        <div className="relative">
            <h2>Journal Entries for {breakDetail.name}</h2>

            <p className='description m-3'>
                View all the saved conditions you have recorded for this break
            </p>
            <Link to={`/app/newentry/${id}`} className="btn-primary mx-auto mb-3 block w-48">New Journal Entry</Link>

            {!loading ? <div>
                {entries.map(entry => {
                    if (!entry.pinned) {
                        return(
                            <EntryTable
                                key={entry._id}
                                entryID={entry._id}
                                breakID={entry.breakID}
                                date={entry.date}
                                startTime={entry.startTime}
                                endTime={entry.endTime}
                                buoyData={entry.buoyData}
                                notes={entry.notes}
                                pinned={entry.pinned}
                            />
                        )
                    } else {
                        return ""
                    }
                })}
            </div> : <Loader />}
        </div>
    )
}

export default BreakEntries;